import Vue from 'vue';
import Component from 'vue-class-component';
import { Rule, ValidationRules } from '@/types';

import { rulesFunctions } from '@cnamts/vue-dot/src/rules';
import { exactLength } from '@/rules/exactLength';
import { exactLengths } from '@/rules/exactLengths';
import { fileAccept } from '@/rules/fileAccept';
import { fileMaxSize } from '@/rules/fileMaxSize';
import { requiredBool } from '@/rules/requiredBool';
import { count } from '@/rules/count';
import { dateRange } from '@/rules/dateRange';

export type getRulesFn = (rules: Rule[]) => void;

@Component
export default class GetRules extends Vue {

	/** All rules (merge Vue Dot and custom ones) */
	rulesFn = {
		...rulesFunctions,
		exactLength,
		exactLengths,
		fileAccept,
		fileMaxSize,
		requiredBool,
		count,
		dateRange
	} as ValidationRules;

	getRules(rules: Rule[]) {
		const validationRules = rules.map((rule: Rule) => {
			// If the rule doesn't exists in Vue Dot
			if (!this.rulesFn[rule.name]) {
				// Return default rule that does nothing
				// (needed because we're in a map function)
				return () => true;
			}

			// If the rules has arguments
			if (rule.args) {
				// Use it with them
				return this.rulesFn[rule.name](...rule.args);
			} else {
				// Else, just take the rule
				return this.rulesFn[rule.name]();
			}
		});

		return validationRules || [];
	}
}
